import React, { useState, useEffect } from 'react'
// import { useSelector } from 'react-redux'
import { Dialog, IconButton, DialogTitle, DialogContent } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
// import { Box } from '@mui/system'
import { toast } from 'react-toastify'

import '../contactos/modalContacts.css'

import { SeccionGeneral } from './SeccionGeneral'
import { useCatalog } from '../../hooks/useCatalog'

export const DialogProfileCatalog = ({ open, setOpen, initialState, handleUpdate, handleNew, initLoadCatalog }) => {

    const { categorias, initLoadCategorias, intCalcUtilidad } = useCatalog()
    const [form, setForm] = useState(initialState)

    useEffect(() => {
        initLoadCategorias()
    }, [initLoadCategorias])

    const handleSave = async (e) => {
        e.preventDefault()

        if (!form.id_categoria && form.id_categoria !== '') {
            toast.warn("Seleccione una categoría")
            return false
        }

        if (form.servicio === '') {
            toast.warn("Ingrese nombre servicio")
            return false
        }

        if (form.id > 0) {
            handleUpdate(form, categorias)
            initLoadCatalog()
        } else {
            handleNew(form, categorias)
        }

        setOpen(false)

    }

    return (
        <Dialog
            className='dialogoContacs'
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="simple-dialog-title"
        >
            <DialogTitle id="scroll-dialog-title">
                {form.id > 0 ?
                    <div>Detalle servicio <span className="text-uppercase">( {form.servicio} )</span></div>
                    :
                    `Nuevo servicio ${form.servicio !== '' ? `( ${form.servicio} )` : ''}`
                }
                <IconButton
                    aria-label="close"
                    style={{ padding: '0', float: 'right' }}
                    onClick={() => setOpen(false)}
                >
                    <CloseIcon style={{ color: '#78667E' }} />
                </IconButton>

            </DialogTitle>
            <DialogContent>
                <SeccionGeneral
                    form={form}
                    setForm={setForm}
                    handleSave={handleSave}
                    categorias={categorias}
                    initLoadCategorias={initLoadCategorias}
                    intCalcUtilidad={intCalcUtilidad}
                />
            </DialogContent>
        </Dialog>
    )
}